import { atom } from "recoil";

export const unknownIriState = atom<Array<string>>({
  key: "unknownIriState",
  default: Array<string>(),
});
